import { render } from "./ClientComponent.vue?vue&type=template&id=32f2f669"
import script from "./ClientComponent.vue?vue&type=script&lang=js"
export * from "./ClientComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__